import type { Campaign, MessageToast } from '~/modules/campaign/types';

import { useUpdateCampaignVariant } from './useUpdateCampaignVariant';
import { useCampaignStore } from '~/modules/campaign';
import { useToast } from '~/hooks/useToast';
import { CAMPAIGN_MSG } from '../constants';

export interface IUpdateCampaign<T extends Campaign> {
  isLoadingUpdate: boolean;
  onUpdateCampaign: (campaign: T, message?: MessageToast) => Promise<T | undefined>;
}

export const useUpdateCampaign = <T extends Campaign>(): IUpdateCampaign<T> => {
  const upsertCampaign = useCampaignStore((state) => state.upsertCampaign);

  const { shopifyToast } = useToast();
  const { updateCampaign } = useUpdateCampaignVariant();

  const onUpdateCampaign = async (
    campaign: T,
    message = CAMPAIGN_MSG.UPDATE,
  ): Promise<T | undefined> => {
    if (!campaign || !campaign.variants) return;

    try {
      const updatedCampaign = await updateCampaign(campaign);
      // const isSyncLivePage = campaignAllowedSyncWithLivePages(campaign);
      // if (isSyncLivePage) await handleSyncToLivePage();

      upsertCampaign(updatedCampaign);
      shopifyToast(message.SUCCESS);
      return updatedCampaign as T;
    } catch (error) {
      shopifyToast(message.FAILED, { isError: true });
      return;
    }
  };

  return {
    isLoadingUpdate: false,
    onUpdateCampaign,
  };
};
